import { AmplifilesClient } from "./api-client";
import {
  CreateTeamDto,
  TeamDto,
  TeamMembersDto,
  UpdateTeamMemberDto,
} from "@repo/api/team";

export class TeamApi {
  static async createTeam(data: CreateTeamDto) {
    const response = await AmplifilesClient.instance.post("/team", data);
    return TeamDto.parse(response.data);
  }

  static async updateTeam(data: CreateTeamDto, teamExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/update`,
      data,
    );
    return TeamDto.parse(response.data);
  }

  static async getTeam(teamExternalId: string) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}`,
    );
    return TeamDto.parse(response.data);
  }

  static async getTeamMembers(teamExternalId: string) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/members`,
    );
    return TeamMembersDto.parse(response.data);
  }

  static async deleteTeamMember(
    teamExternalId: string,
    teamMemberExternalId: string,
  ) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/member/${teamMemberExternalId}/delete`,
    );
    return TeamMembersDto.parse(response.data);
  }

  static async updateTeamMember(
    teamExternalId: string,
    teamMemberExternalId: string,
    data: UpdateTeamMemberDto,
  ) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/member/${teamMemberExternalId}/update`,
      data,
    );
    return TeamMembersDto.parse(response.data);
  }
}
